import { AlertCircle } from "lucide-react";
import { ZButton } from "@/shared/components/button";

interface TableErrorStateProps {
  onRetry: () => void;
}

export function TableErrorState({ onRetry }: TableErrorStateProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center py-12">
      <AlertCircle className="w-10 h-10 text-red-500 mb-3" />
      <p className="text-sm font-medium text-gray-900 mb-1">
        Failed to load vendors
      </p>

      <ZButton
        variant="flat"
        color="danger"
        size="sm"
        onClick={onRetry}
      >
        Try Again
      </ZButton>
    </div>
  );
}
